import React, { useState, useEffect } from "react";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import "../Scrollbar.css";
import { get } from "../../../../../utils/api";

const FacilitySelectionFilter = ({
  selectedFacilities = [],
  setSelectedFacilities,
  url,
  errors,
}) => {
  const [facilities, setFacilities] = useState([]);
  console.log("first21", selectedFacilities);

  useEffect(() => {
    // Fetch all facilities from the backend
    const fetchFacilities = async () => {
      try {
        const response = await get(url);
        // Extract unique facility names from the user data
        const uniqueFacilities = response.data.data
          ? [
              ...new Set(
                response.data.data.map((user) => user.facility.facilityName)
              ),
            ]
          : [
              ...new Set(
                response.data.data.map((user) => user.facility.facilityName)
              ),
            ];
        setFacilities(uniqueFacilities);
      } catch (error) {
        console.error("Error fetching facilities:", error);
      }
    };

    fetchFacilities();
  }, []);

  const handleFacilityChange = (event) => {
    const selectedCountry = event.target.value;

    if (event.target.checked) {
      setSelectedFacilities([...selectedFacilities, selectedCountry]);
    } else {
      setSelectedFacilities(
        selectedFacilities.filter((country) => country !== selectedCountry)
      );
    }
  };

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", ml: 2, height: "90%" }}
    >
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          fontWeight: "bold",
          marginBottom: "30px",
        }}
      >
        Facility
      </Typography>
      <Box className="scrollable-container">
        {facilities.length > 0 ? (
          facilities.map((facility, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  value={facility}
                  checked={selectedFacilities?.includes(facility)}
                  onChange={handleFacilityChange}
                />
              }
              label={facility}
            />
          ))
        ) : (
          <Typography>Loading...</Typography>
        )}
      </Box>
      {errors && (
        <Typography variant="body2" color="#D34040" sx={{ mt: 2 }}>
          {errors}
        </Typography>
      )}
    </Box>
  );
};

export default FacilitySelectionFilter;
